import type { Site } from '../lib/cluster';
import { NETWORK_ORDER, type Network } from '../lib/operators';
import { h, toast } from './dom';
import { saveSite } from './data';

let open: HTMLElement | null = null;

/** Add or edit a manual/verified site. `at` prefills coordinates (e.g. from a map tap). */
export function openSiteForm(site?: Site, at?: { lat: number; lon: number }) {
  open?.remove();
  const lat = h('input', { type: 'text', inputmode: 'decimal', required: true, value: String(site?.lat ?? at?.lat?.toFixed(6) ?? '') });
  const lon = h('input', { type: 'text', inputmode: 'decimal', required: true, value: String(site?.lon ?? at?.lon?.toFixed(6) ?? '') });
  const network = h('select', {}, ...NETWORK_ORDER.map(n => h('option', { value: n, selected: site?.network === n }, n)));
  const nr = h('input', { type: 'checkbox', checked: site?.radios.includes('NR') ?? false });
  const lte = h('input', { type: 'checkbox', checked: site?.radios.includes('LTE') ?? true });
  const name = h('input', { type: 'text', value: site?.name ?? '' });
  const note = h('textarea', { rows: 2 }, site?.note ?? '');

  const form = h('form', { class: 'sheet form', onsubmit: async (e: Event) => {
    e.preventDefault();
    const la = Number(lat.value.replace(',', '.'));
    const lo = Number(lon.value.replace(',', '.'));
    if (!Number.isFinite(la) || !Number.isFinite(lo) || Math.abs(la) > 90 || Math.abs(lo) > 180) { toast('Coordinate non valide'); return; }
    const radios = [lte.checked && 'LTE', nr.checked && 'NR'].filter(Boolean) as string[];
    const s: Site = {
      id: site?.id ?? `manuale-${crypto.randomUUID()}`,
      network: network.value as Network,
      lat: la,
      lon: lo,
      reliability: site?.reliability === 'verificato' ? 'verificato' : 'manuale',
      radios,
      name: name.value.trim() || undefined,
      note: note.value.trim() || undefined,
      source: site?.source ?? 'Marco',
      checkedAt: new Date().toISOString().slice(0, 10),
    };
    try {
      await saveSite(s);
      form.remove();
      open = null;
      toast('Sito salvato');
    } catch (err) {
      toast((err as Error).message);
    }
  } },
    h('button', { type: 'button', class: 'sheet-close', 'aria-label': 'Chiudi', onclick: () => { form.remove(); open = null; } }, '×'),
    h('h2', {}, site ? 'Modifica sito' : 'Aggiungi sito'),
    h('label', {}, 'Operatore', network),
    h('div', { class: 'row' }, h('label', {}, 'Latitudine', lat), h('label', {}, 'Longitudine', lon)),
    !site && !at ? h('p', { class: 'muted small' }, 'Suggerimento: chiudi e tieni premuto sulla mappa per prendere le coordinate da lì.') : null,
    h('div', { class: 'row' }, h('label', { class: 'check' }, lte, '4G'), h('label', { class: 'check' }, nr, '5G')),
    h('label', {}, 'Nome', name),
    h('label', {}, 'Note', note),
    h('div', { class: 'actions' }, h('button', { class: 'primary', type: 'submit' }, 'Salva')),
  );
  document.body.append(form);
  open = form;
}
